export const version = '2.71.1';
//# sourceMappingURL=version.js.map